<template>
  <slot />
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { useMainStore } from '@/stores/mainStore';
import { useMeQuery } from '@/composables/useMeQuery';
import { useLDClient } from 'launchdarkly-vue-client-sdk';
import { useFeatureFlagsStore } from '@/stores/featureFlagsStore';
import { buildLDContext } from '@/plugins/launchdarkly';

const ldClient = useLDClient();
const featureFlagsStore = useFeatureFlagsStore();

// Get the main store (only for teamTwrn)
const mainStore = useMainStore();

const { data: me } = useMeQuery();

const hasUpdatedContext = ref(false);

// Update the LaunchDarkly context
const updateLaunchDarklyContext = async () => {
  if (me.value?.user || (me.value?.org && mainStore.teamTwrn)) {
    // Use shared context builder
    const context = buildLDContext({
      user: me.value?.user,
      org: me.value?.org,
      teams: me.value?.teams,
      teamTwrn: mainStore.teamTwrn,
    });
    const ldFlagSet = await ldClient.identify(context);
    featureFlagsStore.resolveContext?.(ldFlagSet);
    hasUpdatedContext.value = true;
  }
};

// Watch for changes in me data or team selection
watch(
  [
    () => me.value,
    () => mainStore.teamTwrn,
  ],
  () => {
    console.info('Updating LaunchDarkly context');
    updateLaunchDarklyContext();
  },
  { deep: true },
);

// Update the context when the component is mounted
onMounted(() => {
  if (!hasUpdatedContext.value) {
    updateLaunchDarklyContext();
  }
});
</script>
